module.exports = __webpack_public_path__ + "static/media/pid_1.8d476712.svg";